<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Headline:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="90"
            [type]="'content'"
            [blockData]="block.variables?.['YoutubeVideoHeadline'] ?? ''"
            (handleOnChange)="onChange($event, 'YoutubeVideoHeadline')"
            [placeholder]="headlinePlaceholder"
            variable="YoutubeVideoHeadline"
            [isPlainText]="true"
            [blockId]="block.blockId"
            [restrictContent]="true"
          ></app-block-text>
        </div>
      </div>
    </div>
  </div>
</main>
